import { motion } from "framer-motion";

const wearables = [
  "Apple Watch",
  "Oura Ring",
  "Garmin",
  "Fitbit",
  "Amazfit",
  "Samsung Galaxy",
  "Polar",
];

export default function WearablesStrip() {
  return (
    <section className="py-10 border-y border-stone-200/70 bg-white/50" data-testid="wearables-strip">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <p className="text-center text-xs uppercase tracking-[0.25em] text-zoku-ink3 mb-6">
          Syncs beautifully with the gear you already own
        </p>
        <div className="relative overflow-hidden gradient-mask-r">
          <motion.div className="flex gap-14 whitespace-nowrap animate-marquee">
            {[...wearables, ...wearables].map((w, i) => (
              <span
                key={i}
                className="font-heading text-2xl md:text-3xl font-medium text-zoku-ink2 tracking-tight opacity-80 hover:text-zoku-ink transition"
              >
                {w}
              </span>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
}
